/* if( window.jQuery ) {
  $(window).load(function() {
    // $('.shopify-payment-button__more-options')
    console.log('test = ', $('.shopify-payment-button__more-options').length)
    
    $('.shopify-payment-button__more-options').on( "load", function() {
      console.log('element - loaded')
      $('.shopify-payment-button__more-options').clone().addClass('more-options-coppied-button').insertAfter(".shopify-payment-button__more-options");
    });
  })
} */

let vars = {};
let check = window.location.href;
let alreadyIncluded = sessionStorage.getItem('marketing-params-included')
if( check.includes('?') && !alreadyIncluded ) { 
  check.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(substring, key, value) {
      vars[key] = decodeURIComponent(value);
      sessionStorage.setItem(key, vars[key])
  });
  sessionStorage.setItem('marketing-params-included', true)
}